import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import precio from "../../../img/onboarding/precio.jpg";
import { useAppSelector } from "../../../hooks/hooks";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { fetchAxiosNoToken } from "../../../helpers/fetchAxiosNoToken";
import { ButtonRegresar } from "../../../components/ButtonRegresar";
import { ButtonSiguiente } from "../../onboardingHotel/ButtonSiguiente";
import BotonInformacion from "../../../components/helpers/BotonInformacion";

interface PreciosForm {
    precio_base?: string | number;

    personas?: string | number;
}

type errorObject = { [key: string]: string };

export const PrecioTourHotel = () => {
    const { idCasa } = useParams();
    const casa = useAppSelector((state) => state.landing_house.house);
    const [input, setInput] = useState<PreciosForm>({
        precio_base: "",
        personas: "",
    });
    const [errors, setErrors] = useState<PreciosForm>({});
    const [newHorario, setNewHorario] = useState({
        hora_inicio: "",
        hora_final: "",
    });
    const [horarios, setHorarios] = useState<
        { hora_inicio: string; hora_final: string }[]
    >([]);

    const navigate = useNavigate();

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value,
        });
    };

    const validateInput = (form: PreciosForm) => {
        let errores: errorObject = {};

        if (!form.precio_base || Number(form.precio_base) <= 0) {
            errores.precio_base = "Debe ingresar un precio válido";
        }
        if (!form.personas || Number(form.personas) <= 0) {
            errores.personas = "Debe ingresar un número de personas válido";
        }

        return errores;
    };

    const handleSubmit = async () => {
        const errors = validateInput(input);
        setErrors(errors);

        if (Object.entries(errors).length === 0 && horarios.length > 0) {
            try {
                await fetchAxiosToken({
                    url: `/hoteles_tours/updatePrecio/${idCasa}`,
                    method: "put",
                    body: input,
                });
                setTimeout(() => {
                    navigate(`/`);
                }, 3000);
            } catch (error) {
                console.log(error);
                Swal.fire({
                    title: "Error al guardar el precio",
                    text: "Por favor intenta nuevamente.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#029BFC",
                    iconColor: "#029BFC",
                });
            }
        }
    };

    const getOneHabitacion = async () => {
        fetchAxiosToken({
            url: `/hoteles_tours/detalle/${idCasa}`,
        })
            .then((res) => {
                console.log(res);
                setInput(res);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleCapacidad = (currentInput: string, type: string) => {
        if (currentInput === "personas") {
            if (type === "suma") {
                setInput({
                    ...input,
                    personas: Number(input.personas) + 1,
                });
            }
            if (type === "resta" && Number(input.personas) > 0) {
                setInput({
                    ...input,
                    personas: Number(input.personas) - 1,
                });
            }
        }
    };

    const getHorarios = async () => {
        try {
            const res = await fetchAxiosToken({
                url: `/hoteles_tours_horarios/getAll/${idCasa}`,
            });
            setHorarios(res);
        } catch (err) {
            console.log("Error obteniendo horarios", err);
            Swal.fire({
                title: "Error obteniendo horarios",
                icon: "error",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
        }
    };

    const handleAddHorario = async () => {
        if (!newHorario.hora_inicio || !newHorario.hora_final) return;

        try {
            await fetchAxiosToken({
                url: `/hoteles_tours_horarios/`,
                method: "post",
                body: {
                    id_hotel_tours: Number(idCasa),
                    ...newHorario,
                },
            });
            setNewHorario({ hora_inicio: "", hora_final: "" });
            getHorarios(); // actualizar listado
        } catch (err: any) {
            console.error("Error agregando horario", err);
            Swal.fire({
                title: "Error agregando horario",
                text: `${err.response.data.error}`,

                icon: "error",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
        }
    };

    const desactivarHorario = async (idHorario: number) => {
        try {
            await fetchAxiosToken({
                url: `/hoteles_tours_horarios/updateHabilitado/${idHorario}`,
                method: "put",
            });
            getHorarios();
        } catch (err) {
            console.error("Error desactivando horario", err);
        }
    };
    useEffect(() => {
        if (idCasa && Number(idCasa) > 0) {
            getOneHabitacion();
            getHorarios();
        }
    }, []);

    useEffect(() => {
        if (idCasa && Number(idCasa) > 0) getOneHabitacion();
    }, []);

    return (
        <div className="flex flex-col h-screen grid-cols-2 lg:grid">
            <div className="block h-56 md:h-1/3 lg:h-auto bg-black/80">
                <div className="relative flex flex-col items-center justify-center h-full text-center lg:h-screen">
                    <img
                        src={precio}
                        alt="precio"
                        className="object-cover w-full h-full"
                    />
                    <div className="absolute top-0 w-full h-full bg-black opacity-40 "></div>
                    <div className="absolute top-0 flex flex-col items-center justify-center w-2/3 h-full 0">
                        <div className="text-2xl font-bold text-center text-white md:text-4xl 2xl:text-6xl ">
                            Ahora definamos el precio del Tour
                        </div>

                        <div className="mt-5 text-lg text-center text-white md:text-xl 2xl:text-2xl md:mt-14 ">
                            ¡No te preocupes podrás cambiarlo más adelante!
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative flex flex-col justify-center p-6 text-center text-black bg-white lg:overflow-x-auto">
                <ButtonRegresar
                    url={`${`/dashboard-hotel/onboarding-tour/imagenes-tour/${idCasa}`}`}
                    className="absolute top-10 left-10"
                    arrowColor="black"
                    textColor="black"
                />
                <div className="flex flex-col items-center pb-4 mt-14 2xl:mt-24 xl:mt-80 lg:mt-80">
                    <h2 className="text-lg font-medium lg:text-xl 2xl:text-2xl">
                        Define tu precio base por noche
                    </h2>
                    <div className="2xl:mt-10 lg:mt-5 mt-3 w-full flex gap-4 md:w-1/2 max-w-[468px] ">
                        <div className="flex flex-col flex-1 text-start">
                            <label className="text-sm font-medium">
                                Precio por noche
                            </label>
                            <input
                                value={input.precio_base}
                                onChange={handleInputChange}
                                name="precio_base"
                                type={"number"}
                                className="w-full p-3 mt-1 text-black border rounded-lg shadow-md placeholder:italic"
                                placeholder="100"
                            />
                            {errors.precio_base && (
                                <p className="my-1 text-sm font-bold text-red-500 text-md">
                                    {errors.precio_base}
                                </p>
                            )}
                        </div>
                        <div className="flex flex-col ">
                            <label className="text-sm font-medium">
                                Moneda
                            </label>
                            <p className="w-full p-3 mt-1 text-black border rounded-lg shadow-md cursor-not-allowed">
                                {casa.tipo_moneda}
                            </p>
                        </div>
                    </div>
                </div>

                <hr className="px-10 border border-gray-300" />

                <div className="flex flex-col items-center pb-4 mt-5 lg:mt-8 2xl:mt-10 ">
                    <div className="2xl:mt-10 lg:mt-5 mt-3 w-full flex flex-col md:w-1/2 gap-1 max-w-[468px] ">
                        <div className="flex items-center gap-2 mt-3 2xl:mt-5">
                            <label className="text-base font-medium lg:text-lg 2xl:text-2xl">
                                Número de personas
                            </label>
                            <BotonInformacion
                                text={
                                    "Coloca el número máximo de personas (desde 2 años en adelante)"
                                }
                                ver={true}
                                left={14}
                                widthHeight={" w-4 h-4"}
                            />
                        </div>
                        <div className="flex items-center justify-center w-full gap-5 mt-2">
                            <input
                                type={"number"}
                                min={0}
                                name="personas"
                                value={input.personas}
                                onChange={handleInputChange}
                                // placeholder="nombra tu alojamiento"
                                className="w-full  mt-2 mb-2 text-black border border-gray-500 rounded-lg md:mb-1 2xl:p-3 lg:p-2 p-1.5 placeholder:italic"
                            />
                            <button
                                onClick={() =>
                                    handleCapacidad("personas", "resta")
                                }
                                className="flex items-center justify-center p-2 text-2xl text-black bg-gray-300 rounded-lg cursor-pointer 2xl:p-4 lg:p-3 lg:text-3xl hover:bg-gray-400">
                                <svg
                                    className="w-4 h-4 text-black"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    strokeWidth="2"
                                    stroke="currentColor"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round">
                                    {" "}
                                    <path
                                        stroke="none"
                                        d="M0 0h24v24H0z"
                                    />{" "}
                                    <line x1="5" y1="12" x2="19" y2="12" />
                                </svg>
                            </button>

                            <button
                                onClick={() =>
                                    handleCapacidad("personas", "suma")
                                }
                                className="flex items-center justify-center p-2 text-2xl text-black bg-gray-300 rounded-lg cursor-pointer 2xl:p-4 lg:p-3 lg:text-3xl hover:bg-gray-400">
                                <svg
                                    className="w-4 h-4 text-black"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    strokeWidth="2"
                                    stroke="currentColor"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round">
                                    {" "}
                                    <path
                                        stroke="none"
                                        d="M0 0h24v24H0z"
                                    />{" "}
                                    <line x1="12" y1="5" x2="12" y2="19" />{" "}
                                    <line x1="5" y1="12" x2="19" y2="12" />
                                </svg>
                            </button>
                        </div>
                        {errors.personas && (
                            <p className="my-1 text-sm font-bold text-red-500 text-md">
                                {errors.personas}
                            </p>
                        )}
                    </div>
                </div>

                <hr className="px-10 border border-gray-300" />

                <div className="flex flex-col items-center pb-4 mt-5 lg:mt-8 2xl:mt-10 ">
                    <h2 className="text-lg font-medium lg:text-xl 2xl:text-2xl">
                        Agregar horarios del Tour
                    </h2>
                    <div className="2xl:mt-10 lg:mt-5 mt-3 w-full flex flex-col md:w-1/2 gap-4 max-w-[468px] ">
                        <div className="flex gap-4">
                            <input
                                type="time"
                                value={newHorario.hora_inicio}
                                onChange={(e) =>
                                    setNewHorario({
                                        ...newHorario,
                                        hora_inicio: e.target.value,
                                    })
                                }
                                className="w-full p-2 border rounded-lg"
                            />
                            <input
                                type="time"
                                value={newHorario.hora_final}
                                onChange={(e) =>
                                    setNewHorario({
                                        ...newHorario,
                                        hora_final: e.target.value,
                                    })
                                }
                                className="w-full p-2 border rounded-lg"
                            />
                        </div>
                        <button
                            onClick={handleAddHorario}
                            className="p-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600">
                            Agregar horario
                        </button>
                        {horarios.length === 0 && (
                            <p className="text-sm font-medium text-red-500">
                                Necesitas agregar al menos un horario para
                                continuar.
                            </p>
                        )}
                        <div className="w-full mt-4">
                            <h3 className="font-medium">Horarios actuales:</h3>
                            <ul className="mt-2 space-y-1 text-sm">
                                {horarios.map((h: any, idx) => (
                                    <li
                                        key={idx}
                                        className="flex items-center justify-between px-3 py-2 border rounded-lg bg-gray-50">
                                        <span>
                                            ⏰ {h.hora_inicio} - {h.hora_final}
                                        </span>
                                        <button
                                            onClick={() =>
                                                desactivarHorario(h.id)
                                            }
                                            className="text-lg font-bold text-red-500 hover:text-red-700"
                                            title="Eliminar horario">
                                            ✖
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="w-1/2 mx-auto">
                    <ButtonSiguiente
                        onSubmit={() => handleSubmit()}
                        texto="Finalizar"
                    />
                </div>
            </div>
        </div>
    );
};
